import { AppBar, Toolbar, IconButton, Typography, Stack, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

const LABELS = {
  dashboard: { label: 'Tableau de bord', icon: <DashboardOutlinedIcon sx={{ fontSize: 18 }} /> },
  manage:    { label: 'Gérer Entité',    icon: <BusinessOutlinedIcon  sx={{ fontSize: 18 }} /> },
  settings:  { label: 'Paramètres',      icon: <SettingsOutlinedIcon  sx={{ fontSize: 18 }} /> },
};

const TopBar = ({ onMenuClick, activeSection }) => {
  const current = LABELS[activeSection] || LABELS.dashboard;
  return (
    <AppBar position="fixed" elevation={0} sx={{
      display: { md: 'none' },
      bgcolor: 'rgba(255,255,255,0.92)',
      backdropFilter: 'blur(20px)',
      borderBottom: '1px solid rgba(34,197,94,.12)',
      boxShadow: '0 1px 16px rgba(34,197,94,.07)',
    }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <IconButton onClick={onMenuClick} sx={{ color: '#94a3b8', mr: 1, '&:hover': { color: '#16a34a' } }}>
          <MenuIcon />
        </IconButton>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box sx={{
            width: 24, height: 24, borderRadius: '7px',
            background: 'linear-gradient(135deg, #22c55e, #16a34a)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 2px 6px rgba(34,197,94,.25)',
          }}>
            <SportsSoccerIcon sx={{ color: '#fff', fontSize: 14 }} />
          </Box>
          <Typography sx={{
            fontWeight: 900, fontSize: '.95rem',
            background: 'linear-gradient(135deg, #15803d, #22c55e)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          }}>
            ProPlayeur
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={.5} sx={{ color: '#16a34a' }}>
          {current.icon}
          <Typography variant="caption" sx={{ color: '#16a34a', fontWeight: 600 }}>{current.label}</Typography>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;